// icon docs: https://icons.expo.fyi/

import * as React from "react";
import { FontAwesome5 as DefaultIcon } from "@expo/vector-icons";
import styled from "styled-components/native";

import { Theme } from "../../styles";
import { color, Background, background, Color } from "../../styled-component";

const StyledIcon = styled(DefaultIcon)<Background & Color>`
  ${color};
  ${background};
`;

export type IconProps = React.ComponentProps<typeof DefaultIcon> & Background;

function Icon({ size = Theme.spacing * 2.5, ...rest }: IconProps) {
  return <StyledIcon {...rest} size={size} />;
}

export default Icon;
